import {EquipmentData, StoppageKind} from '@hconnect/common/types'
import {DateRange, Iso8601} from '@hconnect/uikit'

export type StoppageCode = {
  code: string
  text: string
}

export enum IssueSortingKey {
  DURATION = 'duration',
  FREQUENCY = 'frequency'
}

export enum IssueGroupingKey {
  STOPPAGE_CODE = 'stoppageCode',
  STOPPED_MAIN_EQUIPMENT = 'stoppedDepartmentUpmId',
  MAIN_EQUIPMENT = 'mainEquipmentNumber',
  EQUIPMENT_NUMBER = 'equipmentNumber',
  TIME_INTERVAL = 'timeInterval'
}

export enum DurationType {
  upTo1h = 'upTo1h',
  between1hAnd24h = 'between1hAnd24h',
  moreThan24h = 'moreThan24h'
}

export enum TimeStepForTitle {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}

export enum TimeStep {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month'
}

export type DurationInterval = {
  start: string
  end: string | null
}

export type StoppageCodeStatistic = {
  stoppedDepartmentUpmIds: string[]
  mainEquipments: EquipmentData[]
  equipments: EquipmentData[]
  hoursStopped: number
  incidentStoppagesCount: number
  incidentHoursStopped: number
  circumstanceStoppagesCount: number
  circumstanceHoursStopped: number
  stoppageCodes: string[]
  stoppageReasons: string[]
}

export type AggregatedStoppageStatisticsResponse = {
  timeStep: TimeStep
  timeStepStart: Iso8601
  stoppagesCount: number
  hoursStopped: number
}[]

export type AggregatedStoppageCodeStatistics = Record<string, StoppageCodeStatistic>

export type AggregatedStoppagesPayload = DateRange<Date> & {
  stoppedDepartmentUpmIds?: string[]
  equipmentNumbers?: string[]
  kinds?: StoppageKind[]
  stoppageCodes?: string[]
  mainEquipmentNumbers?: string[]
  groupBy?: IssueGroupingKey
  timeStep?: TimeStep
}

export type AggregatedStoppage = {
  key: string
  stoppagesCount: number
  hoursStopped: number
}

export type DowntimeStoppage = {
  id: string
  plantId: string
  title: string
  description: string
  stoppedDepartmentUpmId?: string
  mainEquipment: EquipmentData
  equipment: EquipmentData
  start: Iso8601
  end: Iso8601
  stoppageCode: string
  stoppageReason: string
  kind: StoppageKind
  pxTrendId: number
}
